import React, { FC, ChangeEvent, FocusEvent } from 'react';
import classNames from 'classnames';

export type TextQuestionProps = {
  textQuestionValue?: string;
  onAnswerUpdate: (value: string) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>, question?: any) => void;
  question?: any;
  errorId?: any;
  hasError?: boolean;
  inputId?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const TextQuestion: FC<TextQuestionProps> = ({
  textQuestionValue = '',
  onAnswerUpdate,
  onFocus,
  question,
  hasError = false,
  inputId,
  errorId,
  ...rest
}) => {
  const inputWrapClassName = classNames('input', 'input--inset', {
    'input--error': hasError,
  });

  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    onFocus?.(e, question);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onAnswerUpdate(e.target.value);
  };

  return (
    <div className={inputWrapClassName}>
      <input
        className="input__control"
        type="text"
        id={inputId}
        name="text_question"
        value={textQuestionValue}
        onChange={handleChange}
        placeholder="Your answer here"
        onFocus={handleFocus}
        aria-invalid={hasError}
        aria-describedby={hasError ? errorId : undefined}
        {...rest}
      />
    </div>
  );
};

export default TextQuestion;
